import AccountDataTable from '../../../features/account-management/account-list/AccountDataTable'
import AccountFilterHeader from '../../../features/account-management/account-list/AccountFilterHeader'

export default function AccountListPage() {
  return (
    <div className="flex flex-col">
      <AccountFilterHeader />
      <AccountDataTable />
    </div>
  )
}
